import * as React from 'react';
import * as ReactDOM from 'react-dom';
import './fonts.css';
import './index.css';
import './reset.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx